import React from "react";
import { Colors } from "../../design/Colors";
import { Fonts } from "../../design/Font";

export default class TabButton extends React.Component{

    constructor(props){
        super(props);
        this.state={
            isFocused:false,
            secure:false,
        }
    }

    render() {
        const { title, onClick,width,height,selected} = this.props;
        return (
            <div onClick={()=>{if(!selected){onClick()}}} style={{display:"flex", cursor:'pointer', backgroundColor:selected?Colors.faded_blue:Colors.white,width:width, height:height, borderRadius:4,border:'1px solid #ccdef9'}}>
                <span style={{...Fonts.text ,cursor:'pointer', color:Colors.blue, textAlign:'center',width:"100%", alignSelf:'center'}}>{title}</span>
            </div>
        );
    }
}